import { render, staticRenderFns } from "./campaignRules.vue?vue&type=template&id=d3fa81b4&"
import script from "./campaignRules.vue?vue&type=script&setup=true&lang=js&"
export * from "./campaignRules.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports